
import Empty from '@/common/components/Empty';
import { Col, List, Row, Spin } from 'antd';
import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import { useMethods } from '@lhb/hook';
import { surroundCommunityAggregate, surroundShareCommunityAggregate, youthAroundPage, youthShareAroundPage } from '@/common/api/youth';
import { beautifyThePrice, isArray } from '@lhb/func';
import VirtualList from 'rc-virtual-list';
import ListItem from './ListItem';
import { NOT_MORE_DATA } from '../../../../ts-config';

interface CommunityProps {
  mainHeight: number;
  detail: any;
  filters: any;
  curDetail: any;
  setCurDetail: Function;
  isShare?: boolean;
  shareParams?: any;
  modelConfigId: any;
}

/**
 * @Description 小区卡片
 */
const Community:FC<CommunityProps> = ({
  isShare = false,
  shareParams = {},
  detail,
  filters,
  setCurDetail,
  curDetail,
  mainHeight,
  modelConfigId
}) => {
  const ContainerHeight = mainHeight - 100;// tab和分页高度
  const pageRef: any = useRef<number>(1); // 虚拟列表下拉筛选的分页page
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [list, setList] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>({});

  const methods = useMethods({
    onScroll(e: any) {
      // 预留10px
      if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop <= ContainerHeight + 10) {
        if (isLoading) return;
        if (pageRef.current !== NOT_MORE_DATA) {
          pageRef.current += 1;
          methods.loadCommonRimApiData(list);
        }
      }
    },
    getParams() {
      return {
        poiSearchType: 1,
        aoiTypeCategoryId: 1,
        lng: detail?.lng,
        lat: detail?.lat,
        radius: filters?.distance,
        cityName: detail?.cityName,
        modelConfigId,
        modelClusterId: detail?.id,
        ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId } : {}),
        ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
        ...(!isNaN(Number(filters?.secondAoiType)) ? { secondAoiType: filters?.secondAoiType } : {}),
      };
    },
    loadCommonRimApiData: async (lastData) => {
      const sizeVal = 200;
      if (!detail?.cityName) return;
      if (!detail?.lat || !detail?.lng) { // 避免没有经纬度接口异常报错
        setIsLoading(false);
        return;
      }
      try {
        const targetFeatch = isShare ? youthShareAroundPage : youthAroundPage;
        const { objectList } = await targetFeatch({
          page: pageRef.current,
          size: sizeVal,
          ...methods.getParams(),
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        // 将数据合并为一行两个的二维数组
        const rowData = targetData.reduce((acc, cur, idx) => {
          if (idx % 2 === 0) {
            acc.push([cur]);
          } else {
            acc[acc.length - 1].push(cur);
          }
          return acc;
        }, []);
        const totalData = [...lastData, ...rowData];
        // 返回的数据等于size，说明可能还有下一页
        // if (targetData.length === sizeVal && totalData.length < totalNum / 2) {
        //   methods.loadCommonRimApiData(totalData);
        // } else {
        setList(() => (totalData));
        setIsLoading(false);
        // }
      } catch (error) {
        setIsLoading(false);
      }
    },
    getTotal() {
      const targetFetch = isShare ? surroundShareCommunityAggregate : surroundCommunityAggregate;
      // console.log(11111, params);
      targetFetch({ ...methods.getParams(), isShare }).then((res) => {
        // console.log(2222, res);
        setTotalData(res);
      });
    }
  });

  useEffect(() => {
    // 重置分页
    pageRef.current = 1;
    // 重新加载列表
    methods.loadCommonRimApiData([]);
    methods.getTotal();
  }, [filters?.secondAoiType, filters?.distance]);

  return (
    <>
      <div className={styles.communityTotal}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <div className={styles.communityTotalItem}>
              <div className={styles.top}>
                <div className={styles.value}>{beautifyThePrice(totalData.totalHouseholds, ',', 'auto')}</div>
              </div>
              <div className={styles.bottom}>户数</div>
            </div>
          </Col>
          <Col span={12}>
            <div className={styles.communityTotalItem}>
              <div className={styles.top}>
                <div className={styles.value}>{beautifyThePrice(totalData.avgPrice, ',', 'auto')}</div>
                <div className={styles.unit}>元/㎡</div>
              </div>
              <div className={styles.bottom}>平均房价</div>
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles.communityCon}>
        <Spin
          spinning={isLoading}>
          {Array.isArray(list) && list.length
            ? <VirtualList
              data={list}
              height={ContainerHeight}
              itemHeight={80}
              itemKey='id'
              onScroll={methods.onScroll}
              className={styles.listCon}
            >
              {(item: any, index:number) => (
                <List.Item
                  key={index}
                >
                  <ListItem
                    row={item}
                    curDetail={curDetail}
                    setCurDetail={setCurDetail}
                  />
                </List.Item>
              )}
            </VirtualList>
            : <Empty />
          }
        </Spin>
      </div>
    </>
  );
};


export default Community;
